import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { getLanguageCodeFromLocaleOrDefault } from '../utils';

@Injectable({
    providedIn: 'root'
})
export class AcceptLanguageInterceptorService implements HttpInterceptor {
    constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const languageRequest = req.clone({
            setHeaders: {
                'Accept-Language': getLanguageCodeFromLocaleOrDefault(this.locale)
            }
        });

        return next.handle(languageRequest);
    }
}
